import Vue from "vue";
export default Vue.extend({
    name: 'PhotoDescription',
    props: {
        content: {
            type: Object,
            default() {
                return [];
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/pagebuilder-components/PhotoDescription/PhotoDescription.ts
// module id = null
// module chunks = 